// extracted by mini-css-extract-plugin
export default {"boundary":"ErrorBoundary__boundary--_F6ZA","heading":"ErrorBoundary__heading--dzyTe","subHeader":"ErrorBoundary__subHeader--HvxkF"};